import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", {
  class: "alert alert-success",
  "data-cy": "PayPortal.AlreadyPaid.Alert"
}, "You already have a license for this content.", -1)
const _hoisted_2 = { "data-cy": "PayPortal.AlreadyPaid.Heading" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { "data-cy": "PayPortal.AlreadyPaid.Text" }, [
  /*#__PURE__*/_createTextVNode("You can now proceed to your classes. "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("If you encounter any problems, please try logging out and back in again. ")
], -1)


import { prettyDate } from '../modules/frontend';


export default _defineComponent({
  expose: [],
  props: {
    className: { type: String, required: true }
  } as unknown as undefined,
  setup(__props: {
	className: string
}) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("h1", _hoisted_2, _toDisplayString(__props.className), 1),
    _hoisted_3,
    _hoisted_4
  ], 64))
}
}

})